import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem
  , IonLabel,
  IonIcon,
  IonList,
  IonListHeader
  } from '@ionic/react';
import React from 'react';
import { removeSharp} from 'ionicons/icons';
//import { useParams } from 'react-router';
import './About.css';
//import ServiceWorkerWrapper from '../services/ServiceWorkerWrapper';
//import * as serviceWorker from '../serviceWorker';

const About: React.FC = () => {

 const name:string = "About";

 const dtls = [{
  version:'0.4.19',
  date:'27/10/2026',
    detail:[
    'My Task : Version 3"'
  ]
 },{
  version:'0.4.18',
  date:'08/08/2026',
    detail:[
    'Update Module "Site"'
  ]
 },{
  version:'0.4.17',
  date:'04/08/2026',
    detail:[
    'Update Module "Site"'
  ]
 },{
  version:'0.4.16',
  date:'31/07/2026',
    detail:[
    'Update Module "Site"'
  ]
 },{
  version:'0.4.15',
  date:'10/06/2026',
    detail:[
    'Modules : Customized from server',
    'Logout : Clear Active User/Password',
    'Logout : Goto Login Page',
    'Settings : Remove Module Tab'
  ]
 },{
  version:'0.4.14',
  date:'26/05/2026',
    detail:[
    'Change Module Label : "Bams" => "Timesheet", "Site" => "Permit"',
    'Fixed : Signature Page not show',
    'My Tasks : Adjust Modules Buttons',
    'My Tasks : Add Log out Button',
    'My Tasks : Add Subtitle'
  ]
 },{
  version:'0.4.13',
  date:'20/05/2026',
    detail:[
    'Merge Module Bams and Site'
  ]
 },{
  version:'0.4.12',
  date:'07/04/2026',
    detail:[
    'Add PIN Page',
    'Add Log Out Button',
    'Add Go Button in Account Page'
  ]
 },{
  version:'0.4.11',
  date:'09/09/2025',
    detail:[
    'My Tasks : Task : Attached Document : Long file name can\'t be viewed',
  ]
 },{
  version:'0.4.10',
  date:'16/06/2025',
    detail:[
    'Workflows : Read Status Label from server',
  ]
 },{
  version:'0.4.9',
  date:'13/12/2024',
    detail:[
    'My Tasks : Optimize for Speed',
  ]
 },{
  version:'0.4.8',
  date:'10/08/2024',
    detail:[
    'My Tasks : View Doc with Watermark',
    'Signature : Update react-signature-pad-wrapper to 4.0.3'
  ]
 },{
  version:'0.4.7',
  date:'24/06/2024',
    detail:[
    'Ionic Framework : V.7.8.6',
    'My Tasks : Add Button "Settings"',
    'My Tasks : Add Page "Signature"'
  ]
 },{
  version:'0.4.6',
  date:'23/11/2023',
  detail:[
    'Ionic Framework : V.7.5.6',
    'My Tasks : Reason Field : Fixed : Input Value not found',
    'My Tasks : Reason Field : Adjust Position'
  ]
 },{
  version:'0.4.5',
  date:'22/11/2023',
  detail:[
    'Ionic Framework : V.7.5.5',
    'Dar : Upgrade'
  ]
 },{
  version:'0.4.4',
  date:'16/08/2023',
  detail:[
    'Workflows : Form : Send for Approval : Fixed : Create New Workflow show incomplete Tabs',
    'Workflows : Form : Calendar : Fixed : Show Wrong Time'
  ]
 },{
  version:'0.4.3',
  date:'14/08/2023',
  detail:[
    'Ionic Framework : V.7.2.3',
    'Workflows : Form : Create : List Box : Disable Autoselect',
    'Workflows : Form : List Box Options : Word Wrap',
    'Workflows : Form : Inputs : Fixed : Hidden',
    'My Tasks : Inputs : List Box : Fixed : Unselectable',
    'My Tasks : Attach Document : Word Wrap',
    'My Tasks : Comment : If user avatar not exists, show other image'
  ]
 },{
  version:'0.4.2',
  date:'07/08/2023',
  detail:[
    'Ionic Framework : V.7.2.2',
    'Workflows : Form : Add Script BG_SET_VALUE()',
    'Workflows : Form : Inputs and Panel : Special Param : Add "hidden"',
    'Workflows : Form : Send for Approval : Go Back to Previous Page'
  ]
 },{
  version:'0.4.1',
  date:'02/08/2023',
  detail:[
    'Workflows : Form : After Save Draft : Screen is freezed'
  ]
 },{
  version:'0.4.0',
  date:'01/08/2023',
  detail:[
    'Ionic Framework : V.7.2.1',
    'Work Permit : Upgrade',
    'Workflows : Form : "Send for Approval" and "Cancel" Confirmation'
  ]
 },{  
  version:'0.3.7',
  date:'12/07/2023',
  detail:[
    'Workflows : Form : Fixed : Text Area not work',
    'Workflows : Form : Input Display Name : Word Wrap',
    'Workflows : Form : Fixed : Mandatory Calendar and Radio Box cause Save Button malfunction',
    'Workflows : Form : Panel and Inputs : Display Name : html support',
    'Workflows : Form : Inputs : Blank Display Name : Hide Asterisk symbol',
    'Workflows : Form : Script : Add Function BG_PANEL()',
    'Workflows : Form : Fixed : Add Label Type',
    'My Tasks : Task : Show Error from server'
  ]
 },{
  version:'0.3.6',
   date:'27/06/2023',
   detail:[
     'Firebase : JavaScript V.9.23.0',
     'Work Permit : Upgrade',
     'Workflows : Form : Save Draft : Check Mandatory Fields',
     'Workflows : Form : Add Script Feature'
   ]
  },{
   version:'0.3.5',
  date:'07/06/2023',
  detail:[
    'My Tasks : Task : View Document named including "%"',
    'Workflows : Add Upload Component',
    'Workflows : Open Form : Default Tab and Hidden Tab',
    'Workflows : Form : Header : Text Field and Hidden Field : Special Param : "valueFrom"',
    'Workflows : Form : Show ID after saving draft or sending for approval',
    'Workflows : Form : Files Tab : Multiple file upload',
    'Work Permit : Upgrade',
    'Settings : Select Module : Show correct available modules'
  ]
 },{
  version:'0.3.4',
  date:'22/11/2022',
  detail:[
    'Firebase : JavaScript V.9.14.0'
  ]
 },{
  version:'0.3.3',
  date:'12/10/2022',
  detail:[
    'Firebase : JavaScript V.9.12.0',
    'Work Permit : Upgrade'
  ]
 },{
  version:'0.3.2',
  date:'27/09/2022',
  detail:[
    'Firebase : JavaScript V.9.10.0',
    'Workflows : Show Workflow that show in BLeaf Desktop Page',
    'Workflows : Set Button Background Color to transparent',
    'My Tasks : Task : Set Button Background Color to transparent'
  ]
 },{
  version:'0.3.1',
  date:'06/09/2022',
  detail:[
    'Workflows : Show Default Icon on Button if BLeaf not support'
  ]
 },{   
  version:'0.3.0',
  date:'05/08/2022',
  detail:[
    'Firebase : JavaScript V.9.9.3',
    'Work Permit : Upgrade',
    'My Tasks : Save Location while Do Action',
    'Workflows : Save Location while Start'
  ]
 },{   
  version:'0.2.1',
  date:'19/10/2021',
  detail:[
    'Firebase : JavaScript V.9.1.3',
    'My Tasks : Show Watermark Pdf',
    'Settings : Account : Adjust Text Field Border',
    'App : Automatic Update on iOS',
    'Workflows : Change View from List to Button'
  ]
 },{   
  version:'0.2.0',
  date:'20/09/2021',
  detail:[
    'Firebase : JavaScript V.9.1.0',
    'Settings : Other : Get Firebase Token',
    'Workflows : Form : Submit : Show Error if Workflow has already started'
  ]
 },{   
  version:'0.1.9',
  date:'08/09/2021',
  detail:[
    'Workflows : Form : Fixed : Special Param "valueFrom"',
    'My Tasks : Task : Input : Check Box Group Mandatory',
    'My Tasks : Task : Action Button : Special Param : "validate"',
    'Workflows : Form : Check Box : Special Param : "require" : Hide Error Message if unchecked'
  ]
 },{   
  version:'0.1.8',
  date:'04/08/2021',
  detail:[
    'Firebase : JavaScript V.8.10.0',
    'My Tasks : Comment : User Avatar : Handle Unavailable Avatar',
    'My Tasks : Form : Input : Show Old Value',
    'My Tasks : Form : Input : Number Field',
    'My Tasks : Form : Input : Mandatory',
    'My Tasks : Form : Input : List Box : New UI',
    'My Tasks : Form : Input : Trigger',
//    'My Tasks : Form : Input : Script',
    'Settings : Account : Import/Export',
    'Module : Add BCON, Work Permit : Blank Page',
    'Module : Add DAR, IA, BCON and Work Permit : Blank Form Page',
    'Home : More Tab : Reengineering',
    'Workflows : Form : Check Box Group Mandatory',
    'Workflows : Form : Check Box : Special Param : "require"'
  ]
 },{
  version:'0.1.7',
  date:'12/07/2021',
  detail:[
    'Firebase : JavaScript V.8.8.1',
    'Workflows : Form : Reengineering',
    'Workflows : Form : Script',
    'Workflows : Form : Panel : Add Special Param : color,bgColor,weight,hideIcon and style',
    'Workflows : Form : Action Button : Add Menu "Toggle Position"',
    'Workflows : Workflow : Copy : Change Called Url',
    'Workflows : Form : Empty Number Input should show empty string',
    'Workflows : Form : Mandatory Field',
    'Workflows : Form : Panel : Display Height Adjustable',
    'My Tasks : Comment : Show User Avatar : Not Blur',
  ]
 },{   
  version:'0.1.6',
  date:'28/06/2021',
  detail:[
    'Settings : Account : Add Edit Sliding Button',
    'Settings : Account : Remove Active Sliding Button',
    'Settings : Account : Tab Item to Activate Account',
    'Workflows : Form : Change Approval Matrix then change Default User/Group in Assignment Tab',
    'Workflows : Form : Edit : Do not change format while opening form',
    'Workflows : Form : Number Field cause error for sending to approve',
    'Workflows : Form : Remove IonCard from each Tab',
    'My Tasks : Update Title if task count = 0',
    'Module : Add DAR, IA : Blank Page'
  ]
 },{   
  version:'0.1.5',
  date:'16/06/2021',
  detail:[
    'Firebase : JavaScript V.8.6.8',
    'Workflows : Form : List Box : New UI',
    'Settings : Account : Active : Do not show Success Message Dialog',
    'Settings : Account : Active : Change to My Tasks Page after active',
    'Settings : Account : Remove Active Toggle Field',
    'Settings : Account : Active : Login Failed : Clear My Tasks Page',
    'Hosting : Change Firebase account : https://bwiimobile.web.app',
    'Home : My Tasks : Title Format',
    'Settings : Account : Active : Increase Login time out to 20 seconds',
    'Workflows : Form : Use json5 to parse special params',
    'My Tasks : Task : Use json5 to parse special params',
    'Workflows : Form : Field : Read only : New UI'
  ]
 },{   
  version:'0.1.4',
  date:'24/05/2021',
  detail:[
    'Settings : Accounts : Remove Default Account Detail',
    'Workflows : Form : Panel : Parent Name cause error',
    'Service Worker : iOS Safari : Prevent Firebase Error Dialog',
    'Firebase : JavaScript V.8.6.7',
    'Settings : Account : Active : Redraw Tabs from MOBILE_AVAILABLE_MODULE',
    'Workflows : Form : List Box : Auto Select if Option Count = 1',
    'My Tasks : Form : Clear Reason Field before ask new one',
    'My Tasks : iOS : Title does not show task count',
    'My Tasks : iOS : Task does not show description',
    'My Tasks : Detail Panel : Increase font size',
    'Menu : Show Current Account Name',
    'Workflows : Form : Text Area : Min Height = 150px',
    'My Tasks : Comment : Change Format',
    'Settings : Modules : Move Button Icon to top',
    'Settings : Modules : Change Available "More" Group Button to Yellow',
    'Settings : Modules : "More" Group Button should not show "More" Module to Choose',
    'Settings : Modules : Available Module Button Adjusted',
    'Settings : Modules : Keep Preferred Module Button Between Accounts',
    'Workflows : Form : User/Group Picker : Search Result Paging',
    'Workflows : Form : Show/Hide "Files" & "Assignment" Tab',
    'Workflows : Form : Field "format" changed does not show tab',
    'Workflows : Form : Field : Special Param : "readOnly":"CER,1,2,3"'
  ]
 },{
  version:'0.1.3',
  date:'17/02/2021',
  detail:[
    'Workflows : Banner : Adjust Border Width',
    'Workflows : Form : Switch Form by Header Field Value',
    'Settings : Left/Right Handed',
    'Workflows : Show/Hide Create, Edit and Copy button',
    'Workflows : Form : List Box : Change label position to normal',
    'Workflows : Form : Add tab "Files" and "Assignment"',
    'Workflows : Workflow : Copy',
    'Workflows : Workflow : Documents',
    'Workflows : Workflow : History',
    'Workflows : Workflow : Delete',
    'Settings : Accounts : add icon in front of account name',
    'Workflows : Form : Preview',
    'Workflows : Form : Start Workflow',
    'Workflows : Form : Freeze Screen after save or send for approval',
    'Workflows : Form : Expand user/group dialog',
    'Workflows : Form : Save/Send to Approval : Show Success Message and Prevent to tab screen',
    'Workflows : Form : Text Field : Number Format',
    'Workflows : Form : Calendar : Default Value : now'
  ]
 },{
  version:'0.1.2',
  date:'19/01/2021',
  detail:[
    'Workflows : Status "Draft" : Clickable',
    'Workflows : Refresh Button : Reload Config',
    'Workflows : Form',
    'Menu : Hide Test Page'
  ]
 },{
  version:'0.1.1',
  date:'06/01/2021',
  detail:[
    'Workflows : Show Draft Task',
    'Workflows : Show Status Message',
    'Workflows : Configurable Banner'
  ]
 },{
  version:'0.1.0',
  date:'01/12/2020',
  detail:[
    'Workflows : Show Workflows as Group'
  ]
 },{
  version:'0.0.17',
  date:'25/11/2020',
  detail:[
    'My Tasks : Form : Show Reason Dialog but not validate if admin set to "0"',
    'My Tasks : Form : Delete Attached File',
    'My Tasks : Form : Attached File : Show Remove Button for owner only'
  ]
 },{
  version:'0.0.16',
  date:'24/11/2020',
  detail:[
    'My Tasks : Form : Upload Attached File : Show Uploading Dialog',
    'My Tasks : Form : Show Reason Dialog even though set to not show'
  ]
 },{
  version:'0.0.15',
  date:'17/11/2020',
  detail:[
    'My Tasks : Show Wrong Task Count',
    'My Tasks : Load More Tasks : Show Loading Dialog',
    'My Tasks : Form : Upload Attached File'
  ]
 },{
  version:'0.0.14',
  date:'16/11/2020',
  detail:[
    'My Tasks : Paging Record Count : Configurable'
  ]
 },{
  version:'0.0.13',
  date:'13/11/2020',
  detail:[
    'My Tasks : Handle Errors'
  ]
 },{
  version:'0.0.12',
  date:'12/11/2020',
  detail:[
    'My Tasks : Form : Handle Workflow Action Errors',
    'My Tasks : Infinite Scroll'
  ]
 },{
  version:'0.0.11',
  date:'11/11/2020',
  detail:[
    'My Tasks : Form : Handle Internet Connection Lost'
  ]
 },{
  version:'0.0.10',
   date:'10/11/2020',
   detail:[
     'My Tasks : Form : Detail : Word Wrap',
     'My Tasks : Form : Session Expired : Login',
     'My Tasks : Search Bar : Debounce 1000 ms',
     'App : New Icon'
   ]
 },{
  version:'0.0.9',
  date:'09/11/2020',
  detail:[
    'My Tasks : Label : Word Wrap',
    'My Tasks : Label : Less Indent',
    'My Tasks : Add Search Bar',
    'My Tasks : Form : Vertical Align Item Icon Top'
  ]
 },{
  version:'0.0.8',
  date:'06/11/2020',
  detail:[
    'My Tasks : Form : Initialize state before get data',
    'My Tasks : Label : Bold, Multiple lines'
  ]
 },{
  version:'0.0.7',
  date:'05/11/2020',
  detail:[
    'Account : Active Toggle : Show Wrong Status',
    'My Tasks : Register Location after Successful Login'
  ]
 },{
  version:'0.0.6',
  date:'04/11/2020',
  detail:[
    'My Tasks : Form : After button clicked, Remove Waiting Dialog',
    'My Tasks : Form : After button clicked, Refresh My Tasks Page',
    'Account : Save : If not success, cannot continue save again'
  ]
 },{
  version:'0.0.5',
  date:'03/11/2020',
  detail:[
    'My Tasks : Add Loading Spinner',
    'My Tasks : Form : Add Waiting Dialog while button clicked',
    'My Tasks : Form : Button Clicked : Disable Page',
    'Account : Test Login : If not success, cannot continue test again'
  ]
 },{
  version:'0.0.4',
  date:'02/11/2020',
  detail:[
    'My Tasks : Resubmitted Task shows wrong icon color',
    'My Tasks : Form : Do not show Input Section if no Input Control',
    'My Tasks : Form : Warn user if Reason needed',
    'Settings : Account : Test Login : Show Error and remove waiting dialog',
    'Settings : Account : Add Toggle "Active"'
  ]
 },{
  version:'0.0.3',
  date:'31/10/2020',
  detail:[
    'My Tasks : Try Login if failed to fetch data',
    'My Tasks : Form : Show Workflow Id',
    'My Tasks : Form : Descending Order Comment'
  ]
 },{
  version:'0.0.2',
  date:'15/10/2020',
  detail:[
    'Login Location Log',
    'My Tasks : Use Task Edit Config',
    'Multiple Accounts Settings'
  ]
 },{
  version:'0.0.1',
  date:'07/09/2020',
  detail:[
    'My Tasks',
    'Settings',
    'Push Notification (Android Chrome)',
    'QR Code Reader',
    'Geolocation',
    'More Menus'
  ]
 }]

//  serviceWorker.regis.update()
//  window.location.href = window.location.href

return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonItem lines="none">
          <IonLabel color="primary"><strong>BLeaf Mobile</strong></IonLabel>&nbsp;&nbsp;&nbsp;
        </IonItem>

        {dtls.map((dtl,i) => {
                return(
                  <div key={i}>
                  <IonList>
                      <IonListHeader color="primary"><b>V.{dtl.version} : {dtl.date}</b></IonListHeader><br/>
                        {dtl.detail.map((d,j) => {
                            return (
                              <IonItem lines="none">
                              <IonIcon key={j} icon={removeSharp}></IonIcon>&nbsp;
                              <IonLabel key={j} className="ion-text-wrap">{d}</IonLabel>
                              </IonItem>
                            )
                        })}
                  </IonList>
                  <br/>
                  </div>
                )
        })}

        {/*<ServiceWorkerWrapper/>*/}

      </IonContent>
    </IonPage>
    );
};

export default About;
